import React from 'react';

import { cn } from '@/utils/cn';

type TypeBadgeTone = 'model' | 'strategy' | 'claro' | 'blackrock';

interface TypeBadgeProps {
    label: string;
    tone: TypeBadgeTone;
    icon?: React.ReactNode;
    small?: boolean;
}

const TONE_CLASSES: Record<TypeBadgeTone, string> = {
    model: 'bg-seafoam-100 text-seafoam-600',
    strategy: 'bg-cocoa-0 text-cocoa-700',
    claro: 'bg-seafoam-0 text-seafoam-600',
    blackrock: 'bg-black text-white',
};

export const TypeBadge: React.FC<TypeBadgeProps> = ({ label, tone, icon, small }) => (
    <span
        className={cn(
            'inline-flex shrink-0 items-center gap-1.5 rounded font-semibold tracking-wide uppercase',
            TONE_CLASSES[tone],
            small ? 'px-1.5 py-0.5 text-[10px]' : 'py-1 pr-2.5 pl-2 text-xs',
        )}
    >
        {icon}
        {label}
    </span>
);
